module.exports = __webpack_public_path__ + "img/paci_en_4.6df6d786.png";